module.exports = __webpack_public_path__ + "static/media/iphone_12_pro_graphite.8de6eaec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_12_pro_graphite.png
// module id = 2093
// module chunks = 0